module.exports = __webpack_public_path__ + "assets/restartBtn.1c7d2e3d714c38d96f95a3ce93707f2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/play-screen-ui/restartBtn.svg
// module id = 189
// module chunks = 0